import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";

import { datadogRum } from "@datadog/browser-rum";

import { OpenAddUserModal } from "scenes/Settings/components/HubSettings/components/UserInformationForm/components/AddUserModal/action";

import { useSearchName, useSubscribeToAddNewAssigner } from ".";

function useAddNewAssigner(onOpen, onClose, onAssignerAdded = () => {}) {
  const getNameProps = useSearchName();
  const dispatch = useDispatch();
  const [userCandidate, setUserCandidate] = useState(null);
  const [newSelectedUserId, setNewSelectedUserId] = useState(null);

  const resetAssignerCache = () => {
    setUserCandidate(null);
    setNewSelectedUserId(null);
  };

  useSubscribeToAddNewAssigner({
    onCancelled: useCallback(resetAssignerCache, [resetAssignerCache]),
    onCompleted: useCallback(
      (data) => {
        if (!userCandidate) return;
        onAssignerAdded();

        const matchedUser = userCandidate.name
          ? data.find(({ name }) => {
              return name === userCandidate.name;
            })
          : data?.[0];

        if (!matchedUser) return;

        setNewSelectedUserId(matchedUser.id);
        if (onOpen) onOpen();
      },
      [userCandidate, onOpen, onAssignerAdded]
    ),
  });

  return {
    newSelectedUserId: newSelectedUserId,
    resetAssignerCache: resetAssignerCache,
    handleOnChange: (assignee) => {
      if (assignee.type === "crmLists" || assignee.id === "add-user") {
        setUserCandidate(assignee);
        dispatch(
          OpenAddUserModal({
            initialUsers: assignee.name
              ? [
                  {
                    ...(assignee.type === "crmLists"
                      ? { crmListId: assignee.id }
                      : {}),
                    ...getNameProps(assignee.name),
                    inviteNow: true,
                  },
                ]
              : [],
          })
        );

        datadogRum.addAction("add-user-from-assigner");

        if (onClose) onClose();
      }
    },
  };
}

export default useAddNewAssigner;
